import { Link } from "react-router-dom";
import { ArrowLeft, FileText } from "lucide-react";

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-[#09090b]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        
        {/* Back Link */}
        <Link to="/" className="inline-flex items-center gap-2 text-zinc-400 hover:text-white mb-8 transition-colors">
          <ArrowLeft className="h-4 w-4" />
          Tilbage til forsiden
        </Link>

        {/* Header */}
        <div className="flex items-center gap-4 mb-8">
          <div className="w-12 h-12 rounded-xl bg-[#DFFF00]/10 flex items-center justify-center">
            <FileText className="h-6 w-6 text-[#DFFF00]" />
          </div>
          <div>
            <h1 style={{ fontFamily: 'Oswald, sans-serif' }} className="text-3xl font-bold text-white uppercase tracking-tight">
              Vilkår & Betingelser
            </h1>
            <p className="text-sm text-zinc-500">Sidst opdateret: 1. marts 2025</p>
          </div>
        </div>

        {/* Content */}
        <div className="prose prose-invert prose-zinc max-w-none">
          <div className="bg-[#18181b] border border-white/5 rounded-xl p-6 sm:p-8 space-y-8">
            
            <section>
              <h2 className="text-xl font-bold text-white mb-4">1. Generelle Vilkår</h2>
              <p className="text-zinc-400 leading-relaxed">
                Velkommen til FitrackR. Ved at oprette en konto og bruge vores tjenester accepterer du disse vilkår og betingelser. 
                FitrackR er en digital fitness platform, der tilbyder AI-genererede træningsprogrammer, madplaner og tracking-funktioner.
              </p>
              <p className="text-zinc-400 leading-relaxed mt-4">
                Disse vilkår udgør en juridisk bindende aftale mellem dig ("Brugeren") og <span className="text-[#DFFF00]">[FIRMANAVN]</span>, 
                CVR-nr. <span className="text-[#DFFF00]">[CVR-NUMMER]</span>, med adresse på <span className="text-[#DFFF00]">[ADRESSE]</span> ("FitrackR", "vi", "os").
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-white mb-4">2. Brug af Tjenesten</h2>
              <p className="text-zinc-400 leading-relaxed">
                For at bruge FitrackR skal du:
              </p>
              <ul className="list-disc list-inside text-zinc-400 mt-2 space-y-2">
                <li>Være mindst 18 år gammel eller have forældres samtykke</li>
                <li>Oprette en konto med korrekte oplysninger</li>
                <li>Holde dine login-oplysninger fortrolige</li>
                <li>Bruge tjenesten i overensstemmelse med gældende dansk lovgivning</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-white mb-4">3. Abonnement og Betaling</h2>
              <p className="text-zinc-400 leading-relaxed">
                FitrackR tilbyder et månedligt abonnement til 49 DKK/måned. Ved tilmelding får du en 3-dages gratis prøveperiode.
                Efter prøveperioden trækkes betalingen automatisk via det registrerede betalingskort.
              </p>
              <p className="text-zinc-400 leading-relaxed mt-4">
                Alle priser er inkl. moms. Betalinger håndteres sikkert via Stripe. Vi gemmer ikke dine kortoplysninger direkte.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-white mb-4">4. Fortrydelsesret</h2>
              <p className="text-zinc-400 leading-relaxed">
                I henhold til dansk forbrugerlovgivning har du 14 dages fortrydelsesret fra købstidspunktet. 
                Hvis du har brugt tjenesten aktivt i prøveperioden, kan fortrydelsesretten bortfalde helt eller delvist.
              </p>
              <p className="text-zinc-400 leading-relaxed mt-4">
                For at udøve din fortrydelsesret, kontakt os på <span className="text-[#DFFF00]">[EMAIL]</span>.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-white mb-4">5. Opsigelse</h2>
              <p className="text-zinc-400 leading-relaxed">
                Du kan til enhver tid opsige dit abonnement. Opsigelsen træder i kraft ved udgangen af den aktuelle faktureringsperiode.
                Der ydes ingen refusion for ubrugt tid.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-white mb-4">6. Ansvarsfraskrivelse</h2>
              <p className="text-zinc-400 leading-relaxed">
                FitrackR leverer trænings- og madplaner genereret af kunstig intelligens. Disse er vejledende og erstatter ikke 
                professionel rådgivning fra læger, diætister eller personlige trænere.
              </p>
              <p className="text-zinc-400 leading-relaxed mt-4">
                Du bør altid konsultere en læge før du påbegynder et nyt trænings- eller kostprogram, især hvis du har 
                helbredsmæssige udfordringer.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-white mb-4">7. Immaterielle Rettigheder</h2>
              <p className="text-zinc-400 leading-relaxed">
                Alt indhold på FitrackR, herunder tekst, grafik, logoer, ikoner og software, er beskyttet af ophavsret og 
                tilhører FitrackR eller vores licensgivere. Du må ikke kopiere, modificere eller distribuere indholdet uden skriftlig tilladelse.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-white mb-4">8. Ændringer af Vilkår</h2>
              <p className="text-zinc-400 leading-relaxed">
                Vi forbeholder os retten til at ændre disse vilkår. Ved væsentlige ændringer vil du blive notificeret via email 
                mindst 14 dage før ændringerne træder i kraft.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-white mb-4">9. Lovvalg og Værneting</h2>
              <p className="text-zinc-400 leading-relaxed">
                Disse vilkår er underlagt dansk ret. Eventuelle tvister afgøres ved de danske domstole.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-white mb-4">10. Kontakt</h2>
              <p className="text-zinc-400 leading-relaxed">
                Har du spørgsmål til disse vilkår, kan du kontakte os på:
              </p>
              <div className="mt-4 p-4 bg-zinc-900/50 rounded-lg">
                <p className="text-zinc-400"><span className="text-[#DFFF00]">[FIRMANAVN]</span></p>
                <p className="text-zinc-400"><span className="text-[#DFFF00]">[ADRESSE]</span></p>
                <p className="text-zinc-400">CVR: <span className="text-[#DFFF00]">[CVR-NUMMER]</span></p>
                <p className="text-zinc-400">Email: <span className="text-[#DFFF00]">[EMAIL]</span></p>
              </div>
            </section>

          </div>
        </div>

        {/* Footer Links */}
        <div className="mt-8 pt-8 border-t border-white/5 flex flex-wrap gap-4 text-sm text-zinc-500">
          <Link to="/privacy" className="hover:text-[#DFFF00] transition-colors">Privatlivspolitik</Link>
          <span>•</span>
          <Link to="/cookies" className="hover:text-[#DFFF00] transition-colors">Cookie-politik</Link>
          <span>•</span>
          <Link to="/handelsbetingelser" className="hover:text-[#DFFF00] transition-colors">Handelsbetingelser</Link>
        </div>
      </div>
    </div>
  );
}
